import React from 'react';
import { Box, Paper, Stack, Typography } from '@mui/material';
import AutoAwesomeOutlinedIcon from '@mui/icons-material/AutoAwesomeOutlined';
import { alpha } from '@mui/material/styles';

const IncidentContextPanel = ({ contextItems, contextPalette }) => (
  <Paper
    elevation={0}
    sx={{
      p: 2,
      borderRadius: '16px',
      bgcolor: alpha(contextPalette.bg, 0.72),
      border: `1px solid ${alpha(contextPalette.ink, 0.14)}`,
    }}
  >
    <Stack direction="row" spacing={0.75} alignItems="center" sx={{ mb: 1.5 }}>
      <AutoAwesomeOutlinedIcon sx={{ fontSize: 15, color: contextPalette.ink }} />
      <Typography
        sx={{
          fontSize: 11.5,
          fontWeight: 700,
          letterSpacing: '0.4em',
          textTransform: 'uppercase',
          color: contextPalette.ink,
        }}
      >
        Context from today
      </Typography>
    </Stack>

    {contextItems.length > 0 ? (
      <Stack spacing={1.25}>
        {contextItems.map((item) => {
          const Icon = item.icon;
          return (
            <Box key={item.key} sx={{ display: 'flex', gap: 1, alignItems: 'flex-start' }}>
              <Box
                sx={{
                  width: 28,
                  height: 28,
                  borderRadius: '8px',
                  bgcolor: 'rgba(255,255,255,0.7)',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                  color: contextPalette.ink,
                }}
              >
                {Icon ? <Icon sx={{ fontSize: 15 }} /> : null}
              </Box>

              <Box sx={{ minWidth: 0, flex: 1 }}>
                <Box sx={{ display: 'flex', alignItems: 'center', flexWrap: 'wrap', gap: 0.75 }}>
                  <Typography sx={{ fontSize: 14, fontWeight: 650, color: contextPalette.ink, lineHeight: 1.2 }}>
                    {item.title}
                  </Typography>
                  {item.flag ? (
                    <Box
                      sx={{
                        px: 0.85,
                        py: 0.25,
                        borderRadius: 999,
                        bgcolor: 'rgba(255,255,255,0.7)',
                        color: contextPalette.ink,
                        fontSize: 10.5,
                        fontWeight: 650,
                        lineHeight: 1.2,
                        whiteSpace: 'nowrap',
                      }}
                    >
                      {item.flag}
                    </Box>
                  ) : null}
                </Box>
                <Typography
                  sx={{
                    mt: 0.35,
                    fontSize: 12.5,
                    lineHeight: 1.4,
                    color: alpha(contextPalette.ink, 0.8),
                  }}
                >
                  {item.detail}
                </Typography>
              </Box>
            </Box>
          );
        })}
      </Stack>
    ) : (
      <Typography sx={{ fontSize: 12.5, lineHeight: 1.5, color: alpha(contextPalette.ink, 0.85) }}>
        Not enough data yet — log a few more events and patterns will show here.
      </Typography>
    )}
  </Paper>
);

export default IncidentContextPanel;
